import React, { useEffect, useState } from 'react'

import Box from '@mui/material/Box'

import useDocumentContent from 'hooks/documents/useDocumentContent'

function DocumentHTMLContent({ document }) {
  const { getContentByDocumentId } = useDocumentContent({ document })
  const [content, setContent] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    setContent(null)

    if (!document?.id) return

    getContentByDocumentId(document?.id)
      .then((content) => {
        setContent(content)
      })
      .catch((err) => {
        setContent(null)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [document])

  if (!content || loading) return <div></div>

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        border: 'none',
        overflow: 'hidden',
      }}
    >
      <iframe
        title="HTML Document"
        srcDoc={content}
        sandbox="allow-same-origin"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </Box>
  )
}

export default DocumentHTMLContent
